export const elements = [
    {
        id: 1,
        name: "separator",
        title: "Separator",
        label: "Separator",
        value: "",
        default: "",
        isHalf: false,
        canBeHalf: false,
        hasOptions: false
    },
    {
        id: 2,
        name: "input",
        title: "Text",
        label: "Title 1",
        value: "",
        default: "Type text here...",
        isHalf: false,
        canBeHalf: true,
        isRequired: false,
        hasOptions: false
    },
    {
        id: 3,
        name: "textaria",
        title: "Text Area",
        label: "Title 2",
        value: "",
        default: "Type text here...",
        isHalf: false,
        canBeHalf: false,
        isRequired: false,
        hasOptions: false
    },
    {
        id: 4,
        name: "dropdown",
        title: "Dropdown",
        label: "Dropdown Title",
        value: "",
        default: "-- Choose item --",
        isHalf: false,
        canBeHalf: false,
        isRequired: false,
        hasOptions: true,
        options: [
            {
                id: 1,
                value: "Option 1"
            },
            {
                id: 2,
                value: "Option 2"
            },
            {
                id: 3,
                value: "Option 3"
            }
        ]
    },
    {
        id: 5,
        name: "checklist",
        title: "Check list",
        label: "Check list",
        value: [],
        default: "-- Choose item --",
        isHalf: false,
        canBeHalf: true,
        isRequired: false,
        hasOptions: true,
        options: [
            {
                id: 1,
                checked: false,
                value: "Option 1"
            },
            {
                id: 2,
                checked: false,
                value: "Option 2"
            },
            {
                id: 3,
                checked: false,
                value: "Option 3"
            }
        ]
    },
    {
        id: 6,
        name: "radio",
        title: "Radio list",
        label: "Radio list",
        value: "",
        default: "-- Choose item --",
        isHalf: false,
        canBeHalf: true,
        isRequired: false,
        hasOptions: true,
        options: [
            {
                id: 1,
                checked: false,
                value: "Yes"
            },
            {
                id: 2,
                checked: false,
                value: "May be"
            },
            {
                id: 3,
                checked: false,
                value: "No"
            }
        ]
    },
    {
        id: 7,
        name: "counter",
        title: "Counter",
        label: "Counter",
        value: 0,
        default: 0,
        isHalf: false,
        canBeHalf: true,
        isRequired: false,
        hasOptions: false        
    },
    {
        id: 8,
        name: "date",
        title: "Date",
        label: "Date",
        value: new Date(),
        default: 0,
        isHalf: true,
        canBeHalf: true,
        isRequired: false,
        hasOptions: false        
    },
    {
        id: 9,
        name: "time",
        title: "Time",
        label: "Time",
        value: new Date(),
        default: 0,
        isHalf: true,
        canBeHalf: true,
        isRequired: false,
        hasOptions: false        
    }
]